import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";

import {
  StyledMainContainer,
  StyledIcon,
  StyledText,
  StyledTitle,
  StyledDescription,
} from "./ServiceItemStyles";
import { useTranslation } from "react-i18next";

import DecisionIcon from '../../resources/SvgComponents/DecisionIconSvg'
import MrzSupport from '../../resources/SvgComponents/MRZSupport'
import ActivityIcon from '../../resources/SvgComponents/ActivityIconSvg'
import CircleAndQuater from '../../resources/SvgComponents/CircleAndQuaterSvg'

const AgreementsItem = ({ title, description, converted, componentNum }) => {
  const [isAnimated, setIsAnimated] = useState(true)
  const { t } = useTranslation();

  useEffect(() => {
      // Reset animation prop after initial call
      setTimeout(() => {
        setIsAnimated(false)
      }, 3000);
  }, [])

  const Icons = [
    <DecisionIcon />,
    <MrzSupport />,
    <ActivityIcon />,
    <CircleAndQuater />
  ]

  return (
    <StyledMainContainer
      componentNum={componentNum}
      isAnimated={isAnimated}
      id="container"
    >
      <StyledIcon componentNum={componentNum} isAnimated={isAnimated}>
        {Icons[componentNum -1]}
      </StyledIcon>
      <StyledText>
        <StyledTitle>{converted ? title : t(title)}</StyledTitle>
        <StyledDescription>{converted ? description : t(description)}</StyledDescription>
      </StyledText>
    </StyledMainContainer>
  );
};

AgreementsItem.propTypes = {
  icon: PropTypes.object,
  title: PropTypes.string,
  description: PropTypes.string,
  converted: PropTypes.bool
};
export default AgreementsItem;
